export default __webpack_public_path__ + "static/media/result-content-background.d2ac1e64.png";